// extracted by mini-css-extract-plugin
var _1 = "GenericUpsell-module__logo___mxRUP";
export { _1 as "logo" }
